module.exports = __webpack_public_path__ + "static/media/93.aa88a22d.png";